// extracted by mini-css-extract-plugin
export var label = "_fj-2";
export var slideContainer = "_fj-0";
export var slider = "_fj-1";